import { ApiStatus } from '../../types';
import {
    defaultEmploymentsAEM,
    EmploymentsAEM,
    EmploymentsEndpoints,
    EmploymentsRefData,
    EmploymentsState,
    ValidationResponse,
} from './employmentsTypes';

export const defaultGetEmployments = {
    employmentDetails: [
        {
            employmentId: '',
            recordVersion: '',
            employmentCategory: '',
            profession: '',
            startDate: '',
            endDate: '',
            positionTitle: '',
            employmentFrequency: '',
            isPrimaryEmployment: true,
            employer: {
                name: '',
                address: '',
            },
        },
    ],
};

export const defaultEmploymentsRefData: EmploymentsRefData = {
    employmentCategories: {},
    employmentFrequencies: {},
    professions: {},
    professionCategories: {},
    minimumEmployedMonths: 3,
    minimumSelfEmployedMonths: 12,
    content: '',
};

export const defaultValidationResponse: ValidationResponse = {
    result: false,
    validationMessageHeading: '',
    validationMessageDescription: '',
    showConfirmation: false,
    confirmationMessage: '',
};

export const initialStateEmployments: EmploymentsState = {
    content: defaultEmploymentsAEM,
    apiEndpoints: {
        getEmploymentsUrl: '/employment',
        getRefDataUrl: '/employment/refData',
        updateUrl: '/employment/update',
        addUrl: '/employment/create',
        validateUrl: './employment/validate',
        submitUrl: '/employment/complete',
    },
    employments: [],
    refData: defaultEmploymentsRefData,
    validationResponse: defaultValidationResponse,
    getEmploymentsApiStatus: ApiStatus.Idle,
    getRefDataApiStatus: ApiStatus.Idle,
    addEmploymentApiStatus: ApiStatus.Idle,
    updateEmploymentApiStatus: ApiStatus.Idle,
    validateApiStatus: ApiStatus.Idle,
    submitApiStatus: ApiStatus.Idle,
    lastVisitedItem: {
        id: null,
        mode: null,
        isSaved: false,
    },
    isAddMode: false,
};

export const getEmploymentsPreloadData = (content: EmploymentsAEM, apiEndpoints: EmploymentsEndpoints): EmploymentsState => (
    {
        ...initialStateEmployments,
        content,
        apiEndpoints,
    }
);
